import { Account, PaginatedResponse } from '@/types';
import { apiSlice } from './apiSlice';

interface RemainingTime {
  totalSeconds: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export interface VotingSession {
  id: number;
  title: string;
  description: string;
  image: string | null;
  startTime: string;
  endTime: string;
  status: boolean;
  round: number;
  createdRound: number;
  createdAt: string;
  updatedAt: string;
  votings: any[];
  rounds: any[];
  remainingTime: RemainingTime;
}

export interface CreateVotingSessionRequest {
  title: string;
  description: string;
  image: string;
  startTime: string;
  endTime: string;
  round: number;
}

interface VotingSessionResponse {
  data: VotingSession[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}
export const votingApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createVotingSession: builder.mutation<VotingSession, CreateVotingSessionRequest>({
      query: (body) => ({
        url: '/voting/session',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['VotingSessions'],
    }),
    createVotingRound: builder.mutation<
      any,
      {
        sessionId: number;
        body: { title: string; description: string; userIds: number[]; image: string };
      }
    >({
      query: ({ sessionId, body }) => ({
        url: `/voting/session/${sessionId}/round`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['VotingSessions'],
    }),
    updateVotingSession: builder.mutation<
      VotingSession,
      { sessionId: number } & CreateVotingSessionRequest
    >({
      query: ({ sessionId, ...body }) => ({
        url: `/voting/session/${sessionId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['VotingSessions'],
    }),
    deleteVotingSession: builder.mutation<
      void,
      {
        sessionId: number;
      }
    >({
      query: ({ sessionId }) => ({
        url: `/voting/session/${sessionId}`,
        method: 'delete',
      }),
      invalidatesTags: ['VotingSessions'],
    }),
    getVotingSessions: builder.query<VotingSessionResponse, { page: number; limit: number }>({
      query: ({ page, limit }) => ({
        url: `/voting/sessions?page=${page}&limit=${limit}`,
        method: 'GET',
      }),
      providesTags: ['VotingSessions'],
    }),
    getsessionById: builder.query<VotingSession, number>({
      query: (sessionId) => `/voting/session/${sessionId}`,
      providesTags: ['VotingSessions'],
    }),
    getAccounts: builder.query<
      PaginatedResponse<Account>,
      {
        skip?: number;
        take?: number;
        accountType?: string;
      }
    >({
      query: ({ skip = 0, take = 1000, accountType }) => ({
        url: '/users',
        params: {
          skip,
          take,
          accountType,
        },
      }),
      providesTags: ['Accounts'],
    }),
  }),
});

export const {
  useCreateVotingSessionMutation,
  useDeleteVotingSessionMutation,
  useGetVotingSessionsQuery,
  useGetsessionByIdQuery,
  useUpdateVotingSessionMutation,
  useGetAccountsQuery,
  useCreateVotingRoundMutation,
} = votingApi;
